import { Component, OnInit } from '@angular/core';
import { DbService } from '../_services/db.service';
import { Router, ActivatedRoute } from '@angular/router';
import {Auswahl} from '../_models/auswahl';
import {AuthenticationService} from '../_services';
import {User} from '../_models/user';
import {Subscription} from 'rxjs';
import {Auswahl2} from '../_models/auswahl2';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'fischarten-app',
  templateUrl: './fischarten.component.html',
  styleUrls: ['../home/home.component.css']})
export class FischartenComponent implements OnInit {
  art: Auswahl2;
  arten: Auswahl2[];
  filter = '';
  info = '';
  currentUser: User;
  currentUserSubscription: Subscription;



  constructor(
      private router: Router,
      private service: DbService,
      private authenticationService: AuthenticationService
) {
  this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
    this.currentUser = user;
  });
}

  filterArten(): void {
        this.service.getAllFilter('fisch', 'name', this.filter)
          .subscribe(arten => this.arten = arten);
  }


  // tslint:disable-next-line:typedef
  ngOnInit() {
    if (this.currentUser.rechte > 1) {
      this.router.navigate(['/']);
    }
    this.filterArten();
    this.art = { id: 0, name: '', nameeng: ''};
  }

  addPosten(): void {
    this.service.insert('fischtyp', this.art).subscribe(
      () => {
        this.art = { id: 0, name: '', nameeng: ''};
        this.filterArten();
        this.info = 'Erfolgreich gespeichert';
        setTimeout( () => { this.info = ''; }, 5000 );
      }
    );

  }


  goBack(): void {
    this.router.navigate(['/']);
  }

  save(fisch: Auswahl): void {
    this.service.update('fischtyp', fisch)
        .subscribe(
            () => {
              this.filterArten();
              this.info = 'Erfolgreich gespeichert';
              setTimeout( () => { this.info = ''; }, 5000 );
            }
        );
  }

}


